import api from '@/api/index.js'

const inspector_teams = {
  state: {
    loading: false,
    updating: false,
    data: [],
    single: null, // Represents single retrieved team
    created: null,
    error: null
  },

  mutations: {
    SET_INSPECTOR_TEAMS_LOADING: (state, loading) => {
      state.loading = loading;
    },
    SET_INSPECTOR_TEAMS_UPDATING: (state, updating) => {
      state.updating = updating;
    },
    SET_INSPECTOR_TEAMS: (state, teams) => {
      state.data = teams
      state.loading = false;
    },
    SET_INSPECTOR_TEAM: (state, team) => {
      state.single = team
      state.loading = false;
    },
    SET_INSPECTOR_TEAMS_ERROR: (state, error) => {
      state.error = error
    },
    SET_INSPECTOR_TEAM_CREATED: (state, created) => {
      state.created = created
    }
  },

  actions: {
    LoadInspectorTeams({commit}) {
      commit('SET_INSPECTOR_TEAMS_LOADING', true)
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      return api.get('inspector-teams?limit=150&offset=0')
        .then((response) => {
          commit('SET_INSPECTOR_TEAMS', response)
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAMS_LOADING', false)
        })
    },
    GetInspectorTeam({commit}, id) {
      commit('SET_INSPECTOR_TEAMS_LOADING', true)
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      commit('SET_INSPECTOR_TEAM', null)
      return api.get(`inspector-teams/${id}`)
        .then((response) => {
          commit('SET_INSPECTOR_TEAM', response)
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error)
          commit('SET_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAMS_LOADING', false)
        })
    },
    CreateInspectorTeam({commit}, payload) {
      commit('SET_INSPECTOR_TEAMS_UPDATING', true);
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      commit('SET_INSPECTOR_TEAM_CREATED', null)
      return api.post(`inspector-teams`, payload)
        .then((response) => {
          commit('SET_INSPECTOR_TEAM_CREATED', response.body)
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error)
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
    },
    JoinInspectorTeam({commit}, id) {
      commit('SET_INSPECTOR_TEAMS_UPDATING', true);
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      return api.post(`inspector-teams/${id}/join`, null)
        .then((response) => {
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
    },
    LeaveInspectorTeam({commit}, id) {
      commit('SET_INSPECTOR_TEAMS_UPDATING', true);
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      return api.delete(`inspector-teams/${id}/leave`, null)
        .then((response) => {
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
    },
    UpdateTeam({commit}, payload) {
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      return api.put(`inspector-teams/${payload.id}`, payload)
        .then((response) => commit('SET_INSPECTOR_TEAMS_ERROR', null))
        .catch((error) => commit('SET_INSPECTOR_TEAMS_ERROR', error))
    },
    DeleteInspectorTeam({commit}, id) {
      commit('SET_INSPECTOR_TEAMS_UPDATING', true);
      commit('SET_INSPECTOR_TEAMS_ERROR', null)
      return api.delete(`inspector-teams/${id}`)
        .then((response) => {
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
        .catch((error) => {
          commit('SET_INSPECTOR_TEAMS_ERROR', error)
          commit('SET_INTERACTION_ERROR', error.bodyText == '' ? error.url + ' - ' + error.status : error.bodyText)
          commit('SET_INSPECTOR_TEAMS_UPDATING', false);
        })
    }
  }
}

export default inspector_teams
